import { ConfirmModal } from "../../../../components/ui";
import { DropDownList } from "../../../../components/ui";
import EditScopeCustomAddressModal from "../workScopeEdit/EditScopeCustomAddressModal";
import EditScopeCustomTimeModal from "../workScopeEdit/EditScopeCustomTimeModal";
import useDispatchScopeActions from "./useDispatchScopeActions";

/**
 * Shared Dispatch WorkScopeAspect action menu. Used by edit cards as the visible
 * ellipsis menu and by view cards as an invisible menu opened from right-click.
 *
 * @param {Object} props
 * @param {Object} props.scope WorkScopeAspect row.
 * @param {Date|string} props.date Dispatch date for copy/paste actions.
 * @param {"left"|"right"} [props.align] Menu alignment.
 * @param {string} [props.className=""] Extra classes.
 * @param {string} [props.buttonIcon="ellipsis"] Visible trigger icon.
 * @param {boolean} [props.showButton=true] Hide the trigger when opened from context menu.
 * @param {string|number} [props.openKey] External open key for invisible menus.
 * @param {boolean} [props.disableCopy=false] Omit copy actions.
 * @returns {JSX.Element}
 */
export default function DispatchScopeActionMenu({
  scope,
  date,
  align,
  className = "",
  buttonIcon = "ellipsis",
  showButton = true,
  openKey,
  disableCopy = false,
}) {
  const actions = useDispatchScopeActions({ scope, disableCopy });

  return (
    <>
      <DropDownList
        listItems={actions.menuItems}
        date={date}
        buttonIcon={buttonIcon}
        align={align}
        className={className}
        showButton={showButton}
        openKey={openKey}
      />
      <EditScopeCustomAddressModal {...actions.customAddressModal} />
      <EditScopeCustomTimeModal {...actions.customTimeModal} />
      <ConfirmModal {...actions.deleteModal} />
    </>
  );
}
